import { memo, useContext } from 'react';
import styled from '@emotion/styled';
import { BrandInsightsModalContext } from '../BrandInsights/context';
import { InsightsChatIcon } from '../icons/InsightsChat';

type Props = {
  className?: string;
};

export const DiscoverInsights = memo(({ className }: Props) => {
  const [_, onClick] = useContext(BrandInsightsModalContext);

  return (
    <Root
      className={className}
      onClick={onClick}>
      <Wrap>
        <StyledIcon />
        <Title>Discover AI Insights</Title>
      </Wrap>
    </Root>
  );
});

const baseColor = '#415993';
const hoverColor = 'rgb(49 68 117)';

const Wrap = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: '8px 12px',
});

type HoverProps = {
  hovering: boolean;
};

const Title = styled('div')(({ theme }) => ({
  fontSize: 15,
  fontFamily: 'var(--font-semibold)',
  color: theme?.palette?.wl?.enabled ? theme.palette?.primary?.main : baseColor,
  transition: 'color 0.3s linear',

  '&:hover': {
    color: theme?.palette?.wl?.enabled ? theme?.palette?.wl?.primary?.main : hoverColor,
  },
}));

const StyledIcon = styled(InsightsChatIcon)(({ theme }) => ({
  marginRight: 12,
  transition: 'color 0.3s linear',
  color: theme?.palette?.wl?.enabled ? theme?.palette?.wl?.primary?.main : baseColor,

  ':hover': {
    color: theme?.palette?.wl?.enabled ? theme?.palette?.wl?.primary?.main : hoverColor,
  },
}));

const Root = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  borderRadius: 50,
  // @ts-ignore
  border: theme?.palette?.wl?.enabled ? `2px solid ${theme?.palette?.primary?.main}` : `2px solid ${hoverColor}`,
  backgroundImage: theme?.palette?.wl?.enabled ? undefined : `linear-gradient(to right, #fbfbfb , #f0f2f8)`,
  position: 'relative',
  zIndex: 1,
  transition: 'all 0.3s linear',

  ':before': {
    position: 'absolute',
    backgroundImage: theme?.palette?.wl?.enabled ? undefined : `linear-gradient(to right, #f0f2f8 , #E3F4FB)`,
    content: '""',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: -1,
    transition: 'opacity 0.3s linear',
    opacity: 0,
    borderRadius: 50,
  },

  ':hover::before': {
    opacity: 1,
  },

  ':hover': {
    backgroundColor: theme?.palette?.wl?.enabled ? theme?.palette?.skeleton?.main : undefined,
    border: theme?.palette?.wl?.enabled ? `2px solid ${theme?.palette?.primary?.main}` : `2px solid ${hoverColor}`,
    color: theme?.palette?.wl?.enabled ? theme?.palette?.wl?.primary?.main : hoverColor,
  },

  '&:hover > div': {
    color: theme?.palette?.wl?.enabled ? theme?.palette?.wl?.primary?.main : hoverColor,
  },
}));